<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门</div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="queryPersonpointList" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>打卡</div>
          <div class="es-op-box">
            <el-input placeholder="请输入人员名称" v-model="queryObj.username" size="small" class="query" style="float: left"
              clearable @change="() => { this.queryObj.pageNum = 1; loadPersonpointList() }">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-table style="top:6px;" :data="pageData.list" ref="areaTable" border stripe size="mini" height="calc(100vh - 250px)"
            v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="userName" label="人员名称" width="120">
            </el-table-column>
            <el-table-column prop="orgName" label="所在组织" width="120"> 
            </el-table-column>
            <el-table-column prop="createTime" label="打卡时间" width="150">
            </el-table-column>
            <el-table-column prop="location" label="地点">
            </el-table-column>
            <el-table-column prop="remarks" label="备注">
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button type="success" size="mini" title="详情" @click="displayCalendar(scope.row)" round>详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
              @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadPersonpointList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑区域-->
    <el-dialog :visible.sync="visible" :fullscreen="true" @closed="() => this.radio='2'">
      <span slot="title">
        <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>日历显示({{
              selectusername }})
      </span>
       <el-radio-group v-model="radio"  size="mini" @change="to_change">
     <el-radio-button label="1">地图显示</el-radio-button>
      <el-radio-button label="2">日历显示</el-radio-button>
  </el-radio-group>
            <el-row :gutter="15" :style="{ display: calVisible}" style="margin-top:10px; ">
      <el-col>
        <transition name="el-zoom-in-top">
          <el-card class="card">
            <div style="overflow:auto;height: calc(100vh - 179px);">
              <el-calendar v-model="currentdata">
                <template slot="dateCell" slot-scope="{date, data}">
                  <div>
                    <div>{{ data.day.split('-').slice(2).join('') }}</div>
                    <el-row :gutter="8">
                    <el-col :span="6" v-for="item in personlist" :key="item.id" style=""><div v-if="data.day.substr(0, 10) == item.createTime.substr(0, 10)">
                        <el-tag style=" margin: 5px;" @click="openSingleposform(item)">{{ item.createTime.substr(10, 12) }}</el-tag>
                      </div></el-col>
                    </el-row>
                  </div>
                </template>
              </el-calendar>

            </div>
          </el-card>
        </transition>
        <!--<el-button type="primary" class="map_button" icon="el-icon-map-location" @click="go_map">地图显示</el-button>
        <el-button type="success" class="back_button" icon="el-icon-back" @click="go_backmain">返回打卡</el-button>-->

        <el-drawer title="详情" :with-header="false" :visible.sync="singleposVisible" :append-to-body="true" direction="rtl" size="22%">
          <el-card class="drawtitle" shadow="always">
            <div class="demo-drawer__content">
              <br />
              <el-form :model="posinfo">
                <el-form-item label="打卡时间：" label-width="80px">
                  {{ posinfo.createTime }}
                </el-form-item>
                <el-form-item label="打卡经纬：" label-width="80px">
                  {{ posinfo.longitude }}， {{ posinfo.latitude }}
                </el-form-item>
                <el-form-item label="位置：" label-width="80px">
                  {{ posinfo.location }}
                </el-form-item>
                <el-form-item label="备注：" label-width="80px">
                  {{ posinfo.remarks }}
                </el-form-item>
              </el-form>
            </div>
          </el-card>
          <div class="drawmap" id="singlemap"></div>
        </el-drawer>

      </el-col>
    </el-row>

    <div :style="{ display: mapVisible, }" style="margin-top:10px;"> 
      <div class="card-class" id="containercal"></div>
      <!--<el-button type="success" class="map_button" icon="el-icon-back" @click="go_backCalendar">日历显示</el-button>-->
    </div>
    </el-dialog>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'personpoint',
  props: ["funcs"],
  data () {
    return {
      orgTree: [],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      mainVisible: "",
      calVisible: "",
      mapVisible: "none",
      selectusername: '',
      queryuser: [],
      personlist: [],
      loading: false,
      saving: false,
      currentdata: new Date(),
      singleposVisible: false,
      posinfo: [],
      radio: "2",
      visible: false,
      i: ''
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadPersonpointList()
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },

    //从后台查询区域列表
    loadPersonpointList () {
      this.loading = true
      this.$ajax.get('/buss/pointClock/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    queryPersonpointList (orgIds) {
      this.queryObj.pageNum = 1
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.loadPersonpointList()
    },

    //显示日历信息
    displayCalendar (row) {
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      this.visible=true
      this.selectusername = row.userName
      this.currentdata = new Date(row.createTime.replace(/-/g, "/"));
      this.queryuser = { username: row.userName, createtime: this.currentdata }
      this.getpointClockbyperson()
    },

    getpointClockbyperson () {
      this.loading = true
      this.$ajax.get('/buss/pointClock/getpointClockbyperson', this.queryuser).then(msg => {
        this.personlist = msg
        console.log("daka" + this.personlist)
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    //显示地图
    go_map () {


      if (this.personlist != null && this.personlist.length > 0) {
        this.mainVisible = "none"
        this.calVisible = "none"
        this.mapVisible = ""
        this.loadMonthTrackMap()
      }
      else {
        this.$notify({
          title: '警告',
          message: '地图上没有可以显示的打卡记录信息',
          type: 'warning'
        });
      }

    },

    //返回打点首页
    go_backmain () {
      this.mainVisible = ""
      this.calVisible = "none"
      this.mapVisible = "none"
    },

    //返回日历显示
    go_backCalendar () {
      this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
    },

    loadMonthTrackMap () {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
        var map = new AMap.Map("containercal", {  //设置地图容器id
          viewMode: "3D",    //是否为3D地图模式
          zoom: 13,           //初始化地图级别
          center: [this.personlist[0].longitude, this.personlist[0].latitude], //初始化地图中心点位置
        });
        // 创建一个 Marker 实例：
        for (var i = 0; i < this.personlist.length; i++) {
          var marker = new AMap.Marker({
            position: new AMap.LngLat(this.personlist[i].longitude, this.personlist[i].latitude),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: this.personlist[i].createTime,
            data: this.personlist[i]
          });
        
          // 添加标点点击事件
          marker.on('click', (i) => {
        // 在这里执行点击标点后的事件处理逻辑
        //this.openSingleposform(this.personlist[])
        console.log(i.target._originOpts.data)
        this.openSingleposform(i.target._originOpts.data)
      });
          
          // 将创建的点标记添加到已有的地图实例：       
          map.add(marker);
          marker.setLabel({
            direction: 'right',
            offset: new AMap.Pixel(-58, -30),  //设置文本标注偏移量
            content: this.personlist[i].createTime, //设置文本标注内容
          })
        }
      }).catch(e => {
        this.$message.error(e)
      })
    },

    openSingleposform (item) {

      this.posinfo = item
      this.singleposVisible = true
      this.loadtimeMap(item)
    },

    loadtimeMap (item) {
      AMapLoader.load({
        key: '204899ccad5874a75849e637df77e6ff',
        version: '2.0',
      }).then((AMap) => {
        var map = new AMap.Map("singlemap", {
          viewMode: "3D",
          zoom: 13,
          center: [item.longitude, item.latitude],
        });
        var marker = new AMap.Marker({
          position: new AMap.LngLat(item.longitude, item.latitude),
          title: item.createTime
        });
        map.add(marker);
        marker.setLabel({
          direction: 'right',
          offset: new AMap.Pixel(-58, -30),
          content: item.createTime,
        })
      }).catch(e => {
        this.$message.error(e)
      })
    },
    to_change(){
      if(this.radio === "1"){
if (this.personlist != null && this.personlist.length > 0) {
        this.mainVisible = "none"
        this.calVisible = "none"
        this.mapVisible = ""
        this.loadMonthTrackMap()
      }
      else {
        this.$notify({
          title: '警告',
          message: '地图上没有可以显示的打卡记录信息',
          type: 'warning'
        });
      }
      }else{
this.mainVisible = "none"
      this.calVisible = ""
      this.mapVisible = "none"
      }
    }
  },
  watch: {
    currentdata: function () {
      if (this.currentdata.getMonth() != this.queryuser.createtime.getMonth()) {
        this.queryuser.createtime = this.currentdata
        this.getpointClockbyperson()
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.map_button {
  position: absolute;
  top: calc(50vh + 12px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;

}

.back_button {
  position: absolute;
  top: calc(50vh + 72px);
  right: 10px;
  padding: 0px;
  height: 40px;
  opacity: 0.8;
}

.card-class {
  height: calc(100vh - 115px);
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.drawtitle {
  height: calc(100vh - 600px);
}

.drawmap {
 height: calc(100vh - 340px);
}
</style>
